export enum SyncPaths {
  BArch = 'B-Arch',
  CCsv = 'C-Csv',
  DCat = 'D-Cat',
  EImg = 'E-Img',
  FGeo = 'F-Geo',
  GLogs = 'G-Logs',
  HMisc = 'H-Misc',
  JNetCDF = 'J-NetCDF',
}

export const SyncPathsArr = [
  SyncPaths.BArch,
  SyncPaths.CCsv,
  SyncPaths.DCat,
  SyncPaths.EImg,
  SyncPaths.FGeo,
  SyncPaths.GLogs,
  SyncPaths.HMisc,
  SyncPaths.JNetCDF,
]
